import type { Chain } from "viem";
import { telos as _telos } from "viem/chains";

export const telos = {
	..._telos,
	rpcUrls: {
		default: { http: ["https://rpc.telos.net"] },
		public: { http: ["https://rpc.telos.net"] },
	},
} as Chain;
